Vue.component('UserSelector', require('./components/UserPicker/UserSelector'));
Vue.component('SelectorStaffAttendance', require('./components/UserPicker/SelectorStaffAttendance'));
Vue.component('SelectorTeacher', require('./components/UserPicker/SelectorTeacher'));
Vue.component('SelectorClassStudent', require('./components/UserPicker/SelectorClassStudent'));
Vue.component('SelectorStudent', require('./components/UserPicker/SelectorStudent'));
Vue.component('SelectorGroupUser', require('./components/UserPicker/SelectorGroupUser'));
Vue.component('SelectorParent', require('./components/UserPicker/SelectorParent'));
Vue.component('SelectorManager', require('./components/UserPicker/SelectorManager'));

Vue.component('NotAllowRemoveUserTable', require('./components/UserPicker/NotAllowRemoveUserTable'));
Vue.component('SelectedUserTable', require('./components/UserPicker/SelectedUserTable'));



// WEBPACK FOOTER //
// ./resources/assets/js/user_picker_components.js